import {Questionary} from '../questionary';
import {CellItem} from './cellItem';
import reactive = require('../reactive');
import {XmlTagInfo} from '../xmlTagProvider';
import {videoItemView} from "../../ui/items/video";
import {Form} from "../form/form";
import Cell from "../form/cell";
import m from "mithril";

export class VideoItem extends CellItem {

	type:string;
	width:number = 0;
	height:number = 0;
	videoId:string;
	autoPlay:boolean;
	forceWatch:boolean;
	forceWatchTimeout: number;

	private _isFinished = false;

	public static fromXml(config:XmlTagInfo): CellItem {
		return new VideoItem(config);
	}

	private constructor(config: XmlTagInfo){
		super(config);
		const c = config.attributes;
		this.height = parseInt(c['height'], 10) || 0;
		this.width = parseInt(c['width'], 10) || 0;
		this.videoId = c['videoId'];
		this.autoPlay = c['autoPlay'] === 'yes';
		this.type = c['type'];
		this.forceWatchTimeout = parseInt( c['forceWatchTimeout'], 10) * 1000;
		this.forceWatch = c['forceWatch'] === 'yes';
	}

	init(questionary: Questionary, form: Form, cell: Cell) {
		super.init( questionary, form, cell);

		if( this.forceWatchTimeout > 0 ) {
            if (!this.form.timeElapsed) {
                throw new Error("Form timeElapsed variable does not exist.")
            }

			reactive.bind(() => {
			    if (!this.form.timeElapsed) {
                    throw new Error("Form timeElapsed variable does not exist.")
                }

				if( this.forceWatchTimeout <= this.form.timeElapsed() ) {
					this.setFinished();
					// TODO unbind from reactive
				}
			}, [this.form.timeElapsed]);
		}
	}

	getView() {
		return videoItemView(this);
	}

	setFinished() {
		this._isFinished = true;
		m.redraw();
	}

	getFinished(): boolean {
		return this._isFinished;
	}

	blockNext (){
	    return this.cell.isVisible() && this.cell.enabled && this.forceWatch && !this._isFinished;
	}
}